import { Button } from "antd";
import { ColumnProps } from "antd/es/table";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import BeneficiaryGroupContext from "../../../context/beneficiary-groups/context";
import Table from "../../general/table-components/table";
import Space from "../../general/antd/space";
import ViewBtn from "../../general/table-components/actions/view-btn";
import EditBtn from "../../general/table-components/actions/edit-btn";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import { IBeneficiaryGroup } from "../../../models/beneficiary-groups/response";
import eventManager, { EVENT_SUCCESS } from "../../../utils/events";

const BeneficiaryGroupTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { list, actions, loading, query } = useContext(BeneficiaryGroupContext);

  useEffect(() => {
    if (!list?.data) {
      actions.getData();
    }
  }, [list?.data]);

  const columns: ColumnProps<IBeneficiaryGroup>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      align: "center",
      width: 100,
    },
    {
      title: t("name"),
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: t("actions"),
      dataIndex: "actions",
      key: "actions",
      width: 200,
      align: "center",
      render: (_, record) => (
        <Space>
          <ViewBtn onClick={() => navigate(`details/${record.id}`)} />
          <EditBtn onClick={() => navigate(`update/${record.id}`)} />
          <DeleteBtn
            onConfirm={async () => {
              await actions.deleteBeneficiaryGroup(record.id);
              eventManager.emit(EVENT_SUCCESS);
            }}
            loading={loading.includes("delete")}
          />
        </Space>
      ),
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={list?.data ?? []}
      loading={loading.includes("list")}
      showPagination={true}
      scroll={{ x: 800 }}
      total={list?.total}
      size="small"
      pageSize={query.perPage}
      page={query.page}
      onPaginationChange={(page, pageSize) => {
        actions.setQuery({ ...query, page, perPage: pageSize });
      }}
    />
  );
};

export default BeneficiaryGroupTable;
